import axios from '@/utils/request'
import utils from '../utils'
var Qs = require('qs')

export default {
	types: ['newly', 'placed', 'partially', 'finish'],
	passRange: [
		{ label: '1天', key: 'pass1', condition: { passRangeStart: 1, passRangeEnd: 1 } },
		{ label: '2天', key: 'pass2', condition: { passRangeStart: 2, passRangeEnd: 2 } },
		{ label: '3天', key: 'pass3', condition: { passRangeStart: 3, passRangeEnd: 3 } },
		{ label: '4-7天', key: 'pass-4-7', condition: { passRangeStart: 4, passRangeEnd: 7 } },
		{ label: '全部', key: 'pass-all', condition: { passRangeStart: 1, passRangeEnd: 1000 } }
	],
	nearRange: [
		{ label: '今天', key: 'near-today', condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(new Date())) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(new Date())) + ' 23:59:59' } },
		{ label: '明天', key: 'near-tomorrow', condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(utils.nextNDay(1))) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(utils.nextNDay(1))) + ' 23:59:59' } },
		{ label: '后天', key: 'near-datmr', condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(utils.nextNDay(2))) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(utils.nextNDay(2))) + ' 23:59:59' } },
		{ label: '4-7天', key: 'near-4-7', condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(utils.nextNDay(3))) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(utils.nextNDay(6))) + ' 23:59:59' } },
		{ label: '本周', key: 'near-week', condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(utils.beginOfThisWeek())) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfThisWeek()) + ' 23:59:59' } }
	],
	// 2021-01-06
	search(params) {
		return axios.get('/mms/procures?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},
	// 2021-01-05
	create(params) {
		return axios.post('/mms/procures', params)
	},
	// 2021-01-07
	update(id, params) {
		return axios.put('/mms/procures/' + id, params)
	},
	// 2021-01-07
	delete(id) {
		return axios.delete('/mms/procures/' + id)
	},
	// 2021-01-07
	verify(id) {
		return axios.put('/mms/procures/' + id + '/verify')
	},
	// 2021-01-07
	place(id) {
		return axios.put('/mms/procures/' + id + '/place')
	},
	// 2021-01-07
	findItems(id) {
		return axios.get('/mms/procures/' + id + '/items')
	},
	// 2021-01-07
	updateItem(id, itemId, params) {
		return axios.put('/mms/procures/' + id + '/items/' + itemId, params)
	},
	// 2021-01-07
	deleteItem(id, itemId) {
		return axios.delete('/mms/procures/' + id + '/items/' + itemId)
	},
	// 2021-01-07
	addProcureItems(id, params) {
		return axios.post('/mms/procures/' + id + '/items', params)
	},
	// 2021-01-07
	addToMaterial(id, itemId, params) {
		return axios.post('/mms/procures/' + id + '/items/' + itemId + '/add-to-material', params)
	},
	// 2021-01-07
	finishItem(id, itemId) {
		return axios.put('/mms/procures/' + id + '/items/' + itemId + '/finish')
	},
	// 2021-01-07
	batchFinishItem(id, params) {
		return axios.put('/mms/procures/' + id + '/items/batch-finish', params)
	},
	// 2021-01-08
	createProduceFromOrders(params) {
		return axios.post('/mms/procures/create-produce-from-orders', params)
	},
	// 2021-01-09
	createProduceFromPurchases(params) {
		return axios.post('/mms/procures/create-produce-from-purchases', params)
	},
	// 2021-01-07
	itemsExportExcel(params) {
		return axios.get('/mms/procures/items/export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
	},
	// // 2021--01-08
	// newlyCount() {
	// 	return axios.get('/mms/procures/newly-count')
	// },
	// 2021-03-12
	itemsUnSettle(params) {
		return axios.get('/mms/procures/items/un-settle', params)
	},
	// 2021-03-12
	itemsFindBySettlementId(settlementId) {
		return axios.get('/mms/procures/items/find-by-settlement-id/' + settlementId)
	},
	// 2021-03-12
	itemsClearSettle(procureItemId) {
		return axios.put('/mms/procures/items/' + procureItemId + '/clear-settle')
	},
	// 2021-03-12
	itemsUpdateSettleAmount(procureItemId, params) {
		return axios.put('/mms/procures/items/' + procureItemId + '/update-settle-amount', params)
	},
	// 2021-08-18
	virtualCreateProduceByOrder(params) {
		return axios.put('/mms/procures/virtual-create-produce-by-order', params)
	},
	// 2021-08-18
	virtualCreateProduceByPurchase(params) {
		return axios.put('/mms/procures/virtual-create-produce-by-purchase', params)
	},
	// 2021-09-01
	procureOrders(id) {
		return axios.get('/mms/procures/' + id + '/procure-orders', id)
	},
	// 2021-09-01
	procurePurchases(id) {
		return axios.get('/mms/procures/' + id + '/procure-purchases', id)
	},
	// 2021-09-01
	findByOrderUuid(uuid) {
		return axios.get('/mms/procures/find-by-order-uuid/' + uuid)
	},
	// 2021-09-01
	findByPurchaseUuid(uuid) {
		return axios.get('/mms/procures/find-by-purchase-uuid/' + uuid)
	},
	// 2022-01-03
	onTheWayFindByMatierlId(materialId) {
		return axios.get('/mms/procures/on-the-way-find-by-matierl-id/' + materialId)
	},

	// 2022-06-01
	createProduceFromSearchOrders(params) {
		return axios.post('/mms/procures/create-produce-from-search-orders', params)
	},
	// 2022-06-01
	createProduceFromSearchPurchases(params) {
		return axios.post('/mms/procures/create-produce-from-search-purchases', params)
	},

	// 2021-01-07
	findById(id) {
		return axios.get('/mms/procures/' + id)
	}
}

